import { useSelector } from "react-redux";
import { RootState } from "rootReducer";
import { useEffect } from "react";
import StartPage from "pages/StartPage/StartPage";
import StartPageMobile from "pages/StartPageMobile/StartPageMobile";
import { GlobalStyles } from "styles/global";
import { MobileGlobal } from "styles/MobileGlobal";

const App: React.FC = () => {
  const { screenSize } = useSelector((state: RootState) => state.State);

  useEffect(() => {
    const s4workspace = document.getElementById("s4-workspace");
    if (s4workspace) {
      console.log("log av s4workspace", s4workspace);
    } else {
      console.log("s4workspace hittades inte!");
    }

    const msCoreOverlay = document.getElementsByClassName("ms-core-overlay");
    if (msCoreOverlay) {
      console.log("log av s4workspace", msCoreOverlay);
    } else {
      console.log("msCoreOverlay hittades inte!");
    }
  }, []);

  if (screenSize.width !== 0 || null) {
    return (
      <div>
        {screenSize.width > 950 ? <GlobalStyles /> : <MobileGlobal />}
        <div>{screenSize.width > 950 ? <StartPage /> : <StartPageMobile />}</div>
      </div>
    );
  } else {
    return <div />;
  }
};

export default App;
